import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActividadDto, IGetActividades } from '../../../shared/interfaces/database/pqrsd';
import { environment } from '../../../../environments/environment';

// Si existe un DTO específico para Actividad, reemplazar 'any' por el tipo correcto
// import { ActividadDto } from 'ruta/del/dto';

@Injectable({
  providedIn: 'root'
})
export class ActividadesService {
  //environment.apiUrl is the base url of the api
  private readonly apiUrl = `${environment.apiUrl}/api/pqrsd/actividades`;

  constructor(private readonly http: HttpClient) {}

  getActividades(): Observable<IGetActividades[]> {
    return this.http.get<IGetActividades[]>(this.apiUrl);
  }

  createActividad(request: ActividadDto): Observable<boolean> {
    return this.http.post<boolean>(this.apiUrl, request);
  }

  updateActividad(id: number, request: ActividadDto): Observable<boolean> {
    return this.http.put<boolean>(`${this.apiUrl}/${id}`, request);
  }

  deleteActividad(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/${id}`);
  }
}

